import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsAttorneysUsersRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsAttorneysUsersRouterService
  implements SettingsAttorneysUsersRouter
{
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.settings.basename}/${
          modules.attorneys_users.basename
        }`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.settings.basename}/${
        modules.attorneys_users.basename
      }`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
